import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-status_success_tick",
  "use": "icon-status_success_tick-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 25\" id=\"icon-status_success_tick\">\n  <path id=\"icon-status_success_tick_np_tick_801900_000000\" d=\"M14.5,2A12.5,12.5,0,1,0,27,14.5,12.5,12.5,0,0,0,14.5,2Zm6.432,9.479-7.343,7.37a1.327,1.327,0,0,1-.911.391,1.221,1.221,0,0,1-.911-.391l-3.7-3.7A1.308,1.308,0,0,1,9.917,13.3l2.761,2.761L19.11,9.631a1.29,1.29,0,0,1,1.849,0,1.313,1.313,0,0,1-.027,1.848Z\" transform=\"translate(-2 -2)\" fill=\"#3d7e40\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/status_success_tick.svg
// module id = 176
// module chunks = 0 1 2